module.exports = __webpack_public_path__ + "svg/icon-carret-nav.svg";